/**
 * This is loader script.js file
 */

export default {
    name       : 'Loader',
    props : {
        isVisible : {
            type     : Boolean,
            required : true
        },
        text : {
            type     : String,
            required : false,
            default: ''
        }
    }
};
